import {
  AnswerChoice,
  PopulationDNDGrid,
  TargetedFeedback,
} from '../shared/interfaces';

export class DnDGridEvaluator {
  static isCorrect(
    population: PopulationDNDGrid,
    answers: (string | number)[][]
  ): boolean {
    const submittedAnswers: (string | number)[][] = [...answers];
    return (
      submittedAnswers.length > 0 &&
      submittedAnswers[0].length === population.numCorrectAnswers
    );
  }

  static getWrongAnswers(
    population: PopulationDNDGrid,
    answers: (string | number)[][]
  ): (string | number)[][] {
    const wrong = answers.map(answer =>
      answer.filter((a, index) => index >= (population.numCorrectAnswers ?? 0))
    );

    return wrong;
  }

  static getSelectedWrongTargetedFeedback(
    selectedWrongAnswers: (number | string)[][],
    answerChoices: AnswerChoice[]
  ): TargetedFeedback[] {
    const result: TargetedFeedback[] = [];

    answerChoices.forEach(option => {
      if (selectedWrongAnswers.find(k => k.includes(option.id as string))) {
        if (option.targetedFeedback !== undefined) {
          result.push(option.targetedFeedback as TargetedFeedback);
        }
      }
    });

    return result;
  }
}
